import { Assumption } from '@ap/ap-interface-apix-hypotheken-berekening';

export class AssumptionBuilder {
    private interest: number;
    private duration: number;

    withInterest(interest: number): this {
        this.interest = interest;
        return this;
    }

    withDuration(duration: number): this {
        this.duration = duration;
        return this;
    }

    build(): Assumption {
        return {
            interest: this.interest,
            duration: this.duration
        } as Assumption;
    }
}
